import type { JSX } from 'react';

import { LocaleToggle } from './LocaleToggle';
import { ThemeToggle } from './ThemeToggle';

/**
 * Language and theme, side by side in a top bar.
 *
 * They sit on the first screen rather than behind a settings tab: someone who
 * opens the app in a language they cannot read has no way to find a settings
 * tab in it.
 */
export function DisplayPreferences(): JSX.Element {
  return (
    <div className="flex shrink-0 items-center gap-1">
      <LocaleToggle />
      <ThemeToggle />
    </div>
  );
}
